import { render, staticRenderFns } from "./intelligentGuidance.vue?vue&type=template&id=21694cd8&scoped=true"
import script from "./intelligentGuidance.vue?vue&type=script&lang=js"
export * from "./intelligentGuidance.vue?vue&type=script&lang=js"
import style0 from "./intelligentGuidance.vue?vue&type=style&index=0&id=21694cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21694cd8",
  null
  
)

export default component.exports